import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { UserContext } from "../../../context/UserContext"

import { Form, Render } from "../../components";
import { Flex } from "../../container-components";
import { TileButton } from "../../element-components";
import { Defaults } from "../../util";
import { formatDate } from "../../util/formating";
const location = {}
const {
  year: currentYear,
  month: currentMonth,
  day: currentDay,
} = Defaults.currentDate();


const Personal = (props) => {
  const { user } = useContext(UserContext);

  const { onSubmit } = props;

  const history = useNavigate();

  const parentType = location.pathname.includes("profile") ? "profile" : "flow";
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <Form
      isAdd={true}
      onSubmit={onSubmit}
      helperText={(values) => {
        const helperText = {};
        if (user.isSocialSecurityNumber)
          helperText.socialSecurityNumber = `Entered: ***-**-${user.socialSecurityNumber}`;
        return helperText;
      }}
      Inputs={[
        {
          name: "birthday",
          type: "birthday",
          label: "Birthday",
          input: "date",
          disabled: false,
          disableRender: false,
          initialValue: user.dateOfBirth
            ? formatDate({
              data: user.dateOfBirth,
              actions: ["new-date-object"],
              options: ["append-timezone"],
            })
            : "",
          required: {
            type: "date",
            min: {
              value: new Date("12/31/1900"),
              message: "too early",
            },
            max: {
              value: new Date(currentYear - 18, currentMonth, currentDay),
              message: "must be 18 years or older",
            },
          },
          dateConfig: {
            defaultActiveStartDate: new Date(Date.now() - 946728000000),
          },
        },
        {
          name: "socialSecurityNumber",
          type: "text",
          label: "Social Security Number",
          input: "number",
          initialValue: "",
          required: {
            isNotRequired: user.isSocialSecurityNumber,
            type: "ssn",
          },

          disabled: false,
        },
      ]}
      Buttons={({ values, errors, isSubmitting, isDisabled }) => {
        return (
          <Flex row>
            {parentType === "flow" && (
              <TileButton
                color="secondary"
                margin="20px 10px 0"
                text="Next"
                icon="continu"
                type="submit"
                iconType="svg"
                disabled={Object.keys(errors).length > 0 || isSubmitting}
              ></TileButton>
            )}
          </Flex>
        );
      }}
    ></Form>
  );
};

export default Personal;
